import type { MenuItem } from 'primereact/menuitem'
import { TieredMenu as PrimeReactMenu } from 'primereact/tieredmenu'
import type { ForwardedRef } from 'react'
import { forwardRef } from 'react'
import './menu.css'

interface MenuProps {
  items: Array<MenuItem>
}

function Menu({ items }: MenuProps, ref: ForwardedRef<PrimeReactMenu>) {
  return <PrimeReactMenu ref={ref} model={items} popup></PrimeReactMenu>
}

export default forwardRef(Menu)
